import React from 'react';
import PropTypes from 'prop-types';

import ReportList from './ReportList';
import Icon from '../../Icon';

import { COLORS } from '../../../constants/styles';
import { REPORT } from '../../../constants/strings';

import { enhance } from './enhance';

const Report = ({
  reportReasons,
  options,
  intl: { formatMessage },
  onSelect,
}) => {
  const rootReportReasons = reportReasons.filter(
    item => item.resource === options.resource,
  );

  return (
    <div>
      <div styleName="description" className="flex">
        <Icon
          name="exclamation-mark-hover"
          style={{ fill: COLORS.orangePink }}
          className="flex-shrink-0"
        />
        <p styleName="description__text">{formatMessage(REPORT.danger)}</p>
      </div>
      <ReportList list={rootReportReasons} onSelect={onSelect} />
    </div>
  );
};

Report.propTypes = {
  reportReasons: PropTypes.array.isRequired,
  options: PropTypes.object.isRequired,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func,
  }).isRequired,
  onSelect: PropTypes.func.isRequired,
};

export default enhance(Report);



// WEBPACK FOOTER //
// ./src/components/Ui/Report/index.jsx